// extracted by mini-css-extract-plugin
export var main = "mainlogo-module--main--e2557";